// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lotus-promo-carousel {
  --promo-slide-width: 313px;
  --promo-slide-gap: 8px;
  --promo-slide-height: 150px;
  --promo-carousel-nav-bg: color-mix(in srgb, #f9f9f9 70%, transparent);
  position: relative;
  height: var(--promo-slide-height);
  margin-top: 0;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: visible;
  width: 100%;
}

.lotus-promo-carousel .promo-carousel-viewport {
  overflow: hidden;
  width: 100%;
  height: var(--promo-slide-height);
  border-radius: 10px;
}

.lotus-promo-carousel .promo-carousel-viewport--loading {
  opacity: 0;
}

.lotus-promo-carousel .lotus-promo-track {
  display: flex;
  gap: var(--promo-slide-gap);
  height: 100%;
  transition: transform 0.45s ease-in-out;
  animation: none;
  width: max-content;
  will-change: transform;
}

.lotus-promo-carousel .promo-slide {
  flex-shrink: 0;
  width: var(--promo-slide-width);
  height: var(--promo-slide-height);
  padding: 0;
  overflow: hidden;
  border-radius: 8px;
}

.lotus-promo-carousel .promo-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  display: block;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.promo-carousel-skeleton {
  position: absolute;
  inset: 0;
  display: flex;
  gap: var(--promo-slide-gap);
  z-index: 2;
  pointer-events: none;
}

.lotus-skeleton-promo-slide {
  flex-shrink: 0;
  width: var(--promo-slide-width, 313px);
  height: var(--promo-slide-height, 150px);
  border-radius: 8px;
}

.promo-carousel-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: var(--promo-carousel-nav-bg) !important;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background 0.2s ease;
  outline: none;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
}

.promo-carousel-nav svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.promo-carousel-nav:hover {
  background: var(--promo-carousel-nav-bg) !important;
}

.promo-carousel-nav:focus,
.promo-carousel-nav:focus-visible,
.promo-carousel-nav:active {
  outline: none;
  box-shadow: none;
}

.promo-carousel-nav--prev {
  left: 12px;
  padding-right: 2px;
}

.promo-carousel-nav--next {
  right: 12px;
  padding-left: 2px;
}

@media (max-width: 768px) {
  .lotus-promo-carousel {
    --promo-slide-height: 115px;
    margin: 0;
    width: 100%;
    height: auto;
    min-height: var(--promo-slide-height);
    border-radius: 0;
    background: transparent;
    overflow: hidden;
  }

  .lotus-promo-carousel .promo-carousel-viewport {
    height: var(--promo-slide-height);
    border-radius: 0;
    overflow: hidden;
    background: transparent;
  }

  .lotus-promo-carousel .promo-slide {
    height: var(--promo-slide-height);
    border-radius: 8px;
    background: transparent;
  }

  .lotus-promo-carousel .promo-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 8px;
  }

  .lotus-promo-carousel .promo-carousel-nav {
    display: none !important;
  }

  .lotus-skeleton-promo-slide {
    height: 115px;
    border-radius: 8px;
  }
}

/* Home dual-scroll: Lotus banners section pad + full-bleed (no white frame) */
@media (max-width: 1119px) {
  .lotus-home-main-scroll .lotus-promo-carousel {
    margin: 0 -8px 0 !important;
    width: calc(100% + 16px) !important;
    padding: 8px 0 0 8px;
    height: auto !important;
    box-sizing: border-box;
    background: transparent !important;
    overflow: hidden;
  }

  .lotus-home-main-scroll .lotus-promo-carousel .promo-carousel-viewport {
    width: 100%;
    height: 115px;
  }

  .lotus-home-main-scroll .lotus-promo-carousel .promo-slide,
  .lotus-home-main-scroll .lotus-promo-carousel .promo-slide img {
    height: 115px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PromoBannerCarousel/PromoBannerCarousel.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;EAC3B,qEAAqE;EACrE,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,YAAY;EACZ,uCAAuC;EACvC,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,iCAAiC;EACjC,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mDAAmD;EACnD,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;;;EAGE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,2BAA2B;IAC3B,SAAS;IACT,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA,8EAA8E;AAC9E;EACE;IACE,2BAA2B;IAC3B,mCAAmC;IACnC,oBAAoB;IACpB,uBAAuB;IACvB,sBAAsB;IACtB,kCAAkC;IAClC,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".lotus-promo-carousel {\n  --promo-slide-width: 313px;\n  --promo-slide-gap: 8px;\n  --promo-slide-height: 150px;\n  --promo-carousel-nav-bg: color-mix(in srgb, #f9f9f9 70%, transparent);\n  position: relative;\n  height: var(--promo-slide-height);\n  margin-top: 0;\n  margin-bottom: 10px;\n  border-radius: 10px;\n  overflow: visible;\n  width: 100%;\n}\n\n.lotus-promo-carousel .promo-carousel-viewport {\n  overflow: hidden;\n  width: 100%;\n  height: var(--promo-slide-height);\n  border-radius: 10px;\n}\n\n.lotus-promo-carousel .promo-carousel-viewport--loading {\n  opacity: 0;\n}\n\n.lotus-promo-carousel .lotus-promo-track {\n  display: flex;\n  gap: var(--promo-slide-gap);\n  height: 100%;\n  transition: transform 0.45s ease-in-out;\n  animation: none;\n  width: max-content;\n  will-change: transform;\n}\n\n.lotus-promo-carousel .promo-slide {\n  flex-shrink: 0;\n  width: var(--promo-slide-width);\n  height: var(--promo-slide-height);\n  padding: 0;\n  overflow: hidden;\n  border-radius: 8px;\n}\n\n.lotus-promo-carousel .promo-slide img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n  display: block;\n  pointer-events: none;\n  user-select: none;\n}\n\n.promo-carousel-skeleton {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  gap: var(--promo-slide-gap);\n  z-index: 2;\n  pointer-events: none;\n}\n\n.lotus-skeleton-promo-slide {\n  flex-shrink: 0;\n  width: var(--promo-slide-width, 313px);\n  height: var(--promo-slide-height, 150px);\n  border-radius: 8px;\n}\n\n.promo-carousel-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 3;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: var(--promo-carousel-nav-bg) !important;\n  color: #666666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  transition: background 0.2s ease;\n  outline: none;\n  box-shadow: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.promo-carousel-nav svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.promo-carousel-nav:hover {\n  background: var(--promo-carousel-nav-bg) !important;\n}\n\n.promo-carousel-nav:focus,\n.promo-carousel-nav:focus-visible,\n.promo-carousel-nav:active {\n  outline: none;\n  box-shadow: none;\n}\n\n.promo-carousel-nav--prev {\n  left: 12px;\n  padding-right: 2px;\n}\n\n.promo-carousel-nav--next {\n  right: 12px;\n  padding-left: 2px;\n}\n\n@media (max-width: 768px) {\n  .lotus-promo-carousel {\n    --promo-slide-height: 115px;\n    margin: 0;\n    width: 100%;\n    height: auto;\n    min-height: var(--promo-slide-height);\n    border-radius: 0;\n    background: transparent;\n    overflow: hidden;\n  }\n\n  .lotus-promo-carousel .promo-carousel-viewport {\n    height: var(--promo-slide-height);\n    border-radius: 0;\n    overflow: hidden;\n    background: transparent;\n  }\n\n  .lotus-promo-carousel .promo-slide {\n    height: var(--promo-slide-height);\n    border-radius: 8px;\n    background: transparent;\n  }\n\n  .lotus-promo-carousel .promo-slide img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    border-radius: 8px;\n  }\n\n  .lotus-promo-carousel .promo-carousel-nav {\n    display: none !important;\n  }\n\n  .lotus-skeleton-promo-slide {\n    height: 115px;\n    border-radius: 8px;\n  }\n}\n\n/* Home dual-scroll: Lotus banners section pad + full-bleed (no white frame) */\n@media (max-width: 1119px) {\n  .lotus-home-main-scroll .lotus-promo-carousel {\n    margin: 0 -8px 0 !important;\n    width: calc(100% + 16px) !important;\n    padding: 8px 0 0 8px;\n    height: auto !important;\n    box-sizing: border-box;\n    background: transparent !important;\n    overflow: hidden;\n  }\n\n  .lotus-home-main-scroll .lotus-promo-carousel .promo-carousel-viewport {\n    width: 100%;\n    height: 115px;\n  }\n\n  .lotus-home-main-scroll .lotus-promo-carousel .promo-slide,\n  .lotus-home-main-scroll .lotus-promo-carousel .promo-slide img {\n    height: 115px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
